import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfCustomProduct: Guard = function (args): boolean {
  const { context } = args;
  const { product } = context;

  return product?.isCustom ?? false;
};
